import styled from '@emotion/styled';

import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3rem;
	background-color: var(--white);
	padding: 2rem;
	min-height: 380px;

	.form-item {
		.icon.small {
			font-size: 18px !important;
		}
		.typography {
			font-size: 18px !important;

			@media ${Breakpoints.mobileLandscape} {
				font-size: 16px !important;
			}
		}
		.disabled-view-field {
			padding-top: 2.1rem !important;
			padding-bottom: 2.1rem !important;
			border: 1px solid var(--black) !important;
			box-shadow: -2px 2px 0 1px var(--alwaysBlackColor) !important;

			> .typography {
				font-size: 20px !important;

				@media ${Breakpoints.mobileLandscape} {
					font-size: 18px !important;
				}
			}

			@media ${Breakpoints.mobileLandscape} {
				padding-top: 1.7rem !important;
				padding-bottom: 1.7rem !important;
			}

			body[dir='rtl'] & {
				padding-top: 1.3rem !important;
				padding-bottom: 1.3rem !important;
			}
		}
		input {
			font-size: 20px !important;
			padding-top: 3.5rem !important;
			padding-bottom: 3.5rem !important;
			border: 1px solid var(--black) !important;
			box-shadow: -2px 2px 0 1px var(--alwaysBlackColor) !important;

			::placeholder {
				font-size: 20px !important;
			}

			@media ${Breakpoints.mobileLandscape} {
				padding-top: 3rem !important;
				padding-bottom: 3rem !important;
				font-size: 18px !important;

				::placeholder {
					font-size: 18px !important;
				}
			}
		}

		.string-input-error-message-container > .icon {
			font-size: 18px !important;

			@media ${Breakpoints.mobileLandscape} {
				font-size: 16px !important;
			}
		}

		.integer-input-container {
			border: 1px solid var(--black) !important;
			border-radius: 4px !important;
			box-shadow: -2px 2px 0 1px var(--alwaysBlackColor) !important;

			input {
				border: unset !important;
				box-shadow: unset !important;
			}

			button {
				background-color: var(--background-3);
				height: unset;
			}

			> div > div {
				top: 2rem;

				@media ${Breakpoints.mobileLandscape} {
					top: 1.5rem;
				}

				> .typography {
					font-size: 20px !important;

					@media ${Breakpoints.mobileLandscape} {
						font-size: 18px !important;
					}
				}

				body[dir='rtl'] & {
					top: 1.4rem;
				}
			}
		}

		.address-utils {
			padding: 2.3rem;

			.icon {
				font-size: 24px !important;
			}

			@media ${Breakpoints.mobileLandscape} {
				padding: 1.8rem;
			}
		}

		> .form-item-content > .skeleton {
			height: 7rem !important;
		}
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;
	margin-top: 2rem;
	width: 100%;

	button {
		border: 1px solid var(--black) !important;
		padding: 2rem 4.5rem !important;

		> .button-text,
		> .icon {
			font-size: 20px !important;
		}

		@media ${Breakpoints.mobileLandscape} {
			padding: 2rem 2.5rem !important;
		}
	}
`;

export const ResultContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5rem;
	padding: 1rem;
`;

export const DataWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
`;

export const PriceCard = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	border: 1px solid var(--black);
	border-radius: var(--spacing-2);
	padding: 2rem 1.5rem;
	box-shadow: -2px 2px 0 1px var(--alwaysBlackColor);

	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
		gap: 2rem;
		padding: 0;
	}
`;

export const Logo = styled(Image)`
	border: 1px solid var(--black);
	border-radius: var(--spacing-2);
	box-shadow: -2px 2px 0 1px var(--alwaysBlackColor);
`;

export const LeftContentWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 2rem;
	padding-left: 2rem;

	.skeleton {
		width: 120px !important;
		height: 120px !important;
	}

	@media ${Breakpoints.mobileLandscape} {
		padding: 2rem 1.5rem 0 1.5rem;
		justify-content: flex-start;

		.skeleton {
			width: 70px !important;
			height: 70px !important;
		}
	}
`;

export const RightContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 3rem;

	button {
		border: 1px solid var(--black) !important;
		padding: 2rem 4.5rem !important;

		> .button-text {
			font-size: 20px !important;
		}

		@media ${Breakpoints.mobileLandscape} {
			padding: 1.5rem 2.5rem !important;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		padding: 1rem 1.5rem 2rem calc(3.5rem + 70px);
		align-items: flex-start;
		gap: 2rem;
		background-color: #f5f5f5;
		border-radius: 0 0 var(--spacing-2) var(--spacing-2);
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	overflow: auto;

	> .title {
		font-size: 22px !important;

		@media ${Breakpoints.mobileLandscape} {
			font-size: 20px !important;
		}
	}
`;

export const SubtitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 2rem;

	> .subtitle {
		font-size: 22px !important;

		@media ${Breakpoints.mobileLandscape} {
			font-size: 18px !important;
		}
	}

	> .tag .typography {
		font-size: 18px !important;

		@media ${Breakpoints.mobileLandscape} {
			font-size: 14px !important;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
		align-items: flex-start;
		gap: 1rem;
	}
`;

export const PriceContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	gap: 1rem;

	> .first-price-text {
		font-size: 20px !important;

		@media ${Breakpoints.mobileLandscape} {
			font-size: 16px !important;
		}
	}

	> .price-text {
		font-size: 28px !important;
		font-weight: 700 !important;

		@media ${Breakpoints.mobileLandscape} {
			font-size: 22px !important;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		flex-direction: row;
		align-items: center;
	}
`;

export const PackageTabsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: stretch;
	justify-content: center;

	@media ${Breakpoints.mobileLandscape} {
		width: 100%;
	}
`;

export const PackageTab = styled.div`
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2rem 5rem;
	border: 1px solid #000000;

	> .typography {
		font-size: 22px !important;

		@media ${Breakpoints.mobileLandscape} {
			font-size: 18px !important;
		}
	}

	&.FreePackage-tab-title {
		border-radius: 80px 0 0 80px;

		body[dir='rtl'] & {
			border-radius: 0 80px 80px 0;
		}
	}

	&.StarterPackage-tab-title {
		border-left: none;
		border-right: none;
	}

	&.ScalePackage-tab-title {
		border-radius: 0 80px 80px 0;

		body[dir='rtl'] & {
			border-radius: 80px 0 0 80px;
		}
	}

	&.selected {
		border-color: var(--blue);

		> .typography {
			color: var(--blue);
		}
	}

	:hover {
		background-color: var(--background-1);
	}

	@media ${Breakpoints.mobileLandscape} {
		padding: 2rem 0;
		width: 100%;
	}
`;
